import { useParams, Navigate } from "react-router-dom";

const REDIRECT_CATEGORY_SLUGS = [
    "women",
    "unisex",
    "beauty",
    "bakhoor",
    "men",
    "bundle-products",
    "new-arrival",
    "nice-collection",
    "vintage-collection",
  ];

const ProductCategoryRedirect = () => {
  const { slug } = useParams();

  if (REDIRECT_CATEGORY_SLUGS.includes(slug)) {
    return <Navigate to={`/${slug}`} replace />;
  }

  return null;
};

export default ProductCategoryRedirect;
